import { GatsbyImage } from 'gatsby-plugin-image';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import Gallery from '../Gallery';

const CombinedBlock = ({ image, text, gallery, uptitle }) => (
  <div className="flex flex-col md:flex-row gap-12 my-16 items-start md:relative">
    <div className="md:w-1/2 md:sticky md:top-4">
      <GatsbyImage
        image={image.localFile.childImageSharp.gatsbyImageData}
        alt={`Imagen de Referencia de ${image.alternativeText}`}
        className="rounded-3xl"
        placeholder="BLURRED"
      />
      {image.alternativeText && (
        <figcaption className="mt-1 text-xs text-slate-400">
          {`Ref. de ${image.alternativeText}`}
        </figcaption>
      )}
    </div>
    <div className="md:w-1/2 copy">
      <ReactMarkdown rehypePlugins={[rehypeRaw]}>{text}</ReactMarkdown>
    </div>

    {gallery?.length > 0 && (
      <aside className="mt-8">
        <h2 className="text-base mb-4 text-slate-700">
          Algunas de nuestras instalaciones
          {uptitle && (
            <>
              {' '}
              de <strong>{uptitle}</strong>
            </>
          )}
        </h2>
        <Gallery images={gallery} uptitle={uptitle} />
      </aside>
    )}
  </div>
);

export default CombinedBlock;
